// import React, { useMemo, useState } from 'react'
// import styles from './auth.module.css'
// import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'
// import { useTranslation } from 'react-i18next'
//
// const AuthBlock = ({ onAuthSuccess }) => {
//   const { t } = useTranslation()
//   const [pincode, setPincode] = useState('')
//   const [error, setError] = useState('')
//   const [isLoading, setIsLoading] = useState(false)
//
//   const handleSubmit = async (e) => {
//     e.preventDefault()
//
//     if (!pincode.trim()) {
//       setError(t('auth.errorEmpty'))
//       return
//     }
//
//     setIsLoading(true)
//     setError('')
//
//     try {
//       const response = await fetch(
//         `https://3dprostir.aima.in.ua/?ajax=import&action=3dprostir&type=customer&pincode=${pincode}`,
//       )
//       const data = await response.json()
//
//       if (data.status === 'ok') {
//         localStorage.setItem('isAuthenticated', 'true')
//         onAuthSuccess()
//       } else {
//         setError(t('auth.errorInvalid'))
//       }
//     } catch (err) {
//       setError(t('auth.errorConnection'))
//     } finally {
//       setIsLoading(false)
//     }
//   }
//
//   const handleGoBack = () => {
//     window.location.href = '/engineering'
//   }
//
//   const breadcrumbItems = useMemo(
//     () => [
//       { path: '/', label: t('breadcrumbs.home') },
//       { path: '/engineering', label: t('breadcrumbs.engineering') },
//       {
//         path: '/engineering/customer-support',
//         label: t('breadcrumbs.support'),
//       },
//     ],
//     [t],
//   )
//
//   return (
//     <div className={styles.authContainer}>
//       <div className={`customContainer ${styles.auth_content_block}`}>
//         <div className={styles.breadcrumbsWrapper}>
//           <Breadcrumbs items={breadcrumbItems} absolute={true} />
//         </div>
//
//         <div className={styles.authContent}>
//           <div className={styles.authBlock}>
//             <div className={styles.title_block}>
//               <h1 className={styles.title}>{t('auth.title')}</h1>
//               <p className={styles.description}>{t('auth.description')}</p>
//             </div>
//
//             <form onSubmit={handleSubmit} className={styles.form}>
//               <div className={styles.inputGroup}>
//                 <input
//                   type="text"
//                   value={pincode}
//                   onChange={(e) => setPincode(e.target.value)}
//                   className={styles.input}
//                   placeholder={t('auth.inputPlaceholder')}
//                   disabled={isLoading}
//                 />
//               </div>
//
//               {error && <div className={styles.error}>{error}</div>}
//
//               <button
//                 type="submit"
//                 className={styles.submitButton}
//                 disabled={isLoading}
//               >
//                 {isLoading ? t('auth.buttonLoading') : t('auth.buttonSubmit')}
//               </button>
//             </form>
//
//             <button onClick={handleGoBack} className={styles.backButton}>
//               {t('auth.buttonBack')}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
//
// export default AuthBlock

import React, { useMemo, useState } from 'react'
import styles from './auth.module.css'
import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'
import { useTranslation } from 'react-i18next'

const AuthBlock = ({ onAuthSuccess }) => {
  const { t } = useTranslation()
  const [pincode, setPincode] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!pincode.trim()) {
      setError(t('auth.errorEmpty'))
      return
    }

    setIsLoading(true)
    setError('')

    try {
      const response = await fetch(
        `https://3dprostir.aima.in.ua/?ajax=import&action=3dprostir&type=customer&pincode=${pincode}`,
      )

      if (!response.ok) {
        throw new Error('Network error')
      }

      const data = await response.json()

      // Перевіряємо чи є customer_id в відповіді
      if (data && data.customer_id) {
        localStorage.setItem('isAuthenticated', 'true')
        onAuthSuccess(data)
      } else {
        setError(t('auth.errorInvalid'))
      }
    } catch (err) {
      setError(t('auth.errorConnection'))
      console.error('Auth error:', err)
    } finally {
      setIsLoading(false)
    }
  }

  const handleGoBack = () => {
    window.location.href = '/engineering'
  }

  const breadcrumbItems = useMemo(
    () => [
      { path: '/', label: t('breadcrumbs.home') },
      { path: '/engineering', label: t('breadcrumbs.engineering') },
      {
        path: '/engineering/customer-support',
        label: t('breadcrumbs.support'),
      },
    ],
    [t],
  )

  return (
    <div className={styles.authContainer}>
      <div className={`customContainer ${styles.auth_content_block}`}>
        <div className={styles.breadcrumbsWrapper}>
          <Breadcrumbs items={breadcrumbItems} absolute={true} />
        </div>
        <div className={styles.authContent}>
          <div className={styles.authBlock}>
            <div className={styles.title_block}>
              <h1 className={styles.title}>{t('auth.title')}</h1>
              <p className={styles.description}>{t('auth.description')}</p>
            </div>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.inputGroup}>
                <input
                  type="text"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                  className={styles.input}
                  placeholder={t('auth.inputPlaceholder')}
                  disabled={isLoading}
                />
              </div>
              {error && <div className={styles.error}>{error}</div>}
              <button
                type="submit"
                className={styles.submitButton}
                disabled={isLoading}
              >
                {isLoading ? t('auth.buttonLoading') : t('auth.buttonSubmit')}
              </button>
            </form>
            <button onClick={handleGoBack} className={styles.backButton}>
              {t('auth.buttonBack')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthBlock
